import(/* webpackMode: "eager" */ "/opt/buildhome/repo/app/about/page.tsx");
